/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-10 00:22:39
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-11 15:52:18
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelLegal/Components/HOC/index.tsx
 */
import SectionHOC from 'src/layout/EditorPageLayout/EditorCollapsePageLayout/SectionHOC';
export default SectionHOC;
